// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__3DMk5","items":"Faq_items__2OBEP","question":"Faq_question__XjoXG"};